import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';
import { navLinks } from '../constants';
import Button from './Button';

const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-white/10 bg-background/80 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-6 px-6 py-4 lg:px-8">
        <NavLink to="/" className="flex items-center gap-3 rounded-2xl border border-white/10 bg-white/5 px-3 py-2 transition hover:border-primaryLight/40">
          <img src="/logo.png" alt="Genius KODS logo" className="h-10 w-10 rounded-2xl border border-white/10 bg-background p-2 shadow-glow" />
          <span className="text-lg font-semibold uppercase tracking-[0.18em] text-white">
            Genius <span className="bg-gradient-to-r from-primaryLight to-primary bg-clip-text text-transparent">KODS</span>
          </span>
        </NavLink>

        <button
          className="inline-flex items-center justify-center rounded-full border border-white/10 bg-white/5 p-3 text-white lg:hidden"
          onClick={() => setOpen((prev) => !prev)}
          aria-label="Toggle navigation"
        >
          <span className="text-xl">{open ? '✕' : '☰'}</span>
        </button>

        <nav className={`hidden flex-1 items-center justify-center gap-8 lg:flex ${open ? 'block' : ''}`}>
          {navLinks.map((link) => (
            <NavLink
              key={link.path}
              to={link.path}
              className={({ isActive }) =>
                `text-sm font-medium transition ${
                  isActive ? 'text-primary' : 'text-textSecondary hover:text-white'
                }`
              }
              onClick={() => setOpen(false)}
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-4 lg:flex">
          <Button to="/contact">Get Started</Button>
        </div>
      </div>

      {open && (
        <motion.div
          initial={{ opacity: 0, y: -16 }}
          animate={{ opacity: 1, y: 0 }}
          className="border-t border-white/10 bg-background/95 px-6 py-5 lg:hidden"
        >
          <div className="flex flex-col gap-4">
            {navLinks.map((link) => (
              <NavLink
                key={link.path}
                to={link.path}
                className={({ isActive }) =>
                  `rounded-2xl px-4 py-3 text-sm font-medium transition ${
                    isActive ? 'bg-white/10 text-gold' : 'text-slate-200 hover:text-white'
                  }`
                }
                onClick={() => setOpen(false)}
              >
                {link.label}
              </NavLink>
            ))}
          </div>
        </motion.div>
      )}
    </header>
  );
};

export default Navbar;
